<script setup>
import { onMounted, ref } from 'vue';
import { useFelixBagAuxStore, useGlobalStateStore } from '../../../store';

const felixBagAuxStore = useFelixBagAuxStore();
const globalStateStore = useGlobalStateStore();
const showFormNota = ref(true)
const form = ref(null)

onMounted(() => {
  felixBagAuxStore.pauseAfter(19000)
});

const nota = ref(null)
const comentario = ref("")
const criterios = ["Praticidade", "Inovação", "Agilidade", "Humanização"]
const criteriosSelecionados = ref([]);

async function submitNota(event) {
  const results = await event
  console.log("Results: ", results)
  if (results.valid &&  showFormNota.value === false){
    felixBagAuxStore.saveEvent(`avaliacao_final_nota`, 'form_submit', nota.value)
    felixBagAuxStore.saveEvent(`avaliacao_final_comentario`, 'form_submit', comentario.value)
    felixBagAuxStore.saveEvent(`avaliacao_final_criterios`, 'form_submit', criteriosSelecionados.value.join(', '))
    if (globalStateStore.globalState.selectedData.profile.name === 'acolhimento'){
      globalStateStore.globalState.selectedData.doneAvaliacao = true
      felixBagAuxStore.seekTo(felixBagAuxStore.scenes.final_acolhimento)
    } else {
      globalStateStore.globalState.selectedData.doneAvaliacao = true
      felixBagAuxStore.seekTo(felixBagAuxStore.scenes.final_cuidados)
    }
  }
  if (results.valid) {
    showFormNota.value = false
  }
}

function required(v) {
  if (v) return true

  return "Campo obrigatório"
}

function range(value) {
  if (value >= 0 && value <= 10) return true

  return 'A avaliação precisa ser entre 0 a 10'
}

</script>

<template>
  <div id="avaliacao-final">
    <img style="width: 70%; margin: 0% 15%"
      src="//overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/16d3dfa1-ba14-470f-8d1f-868105727002.svg"
      alt="">

    <div v-if="showFormNota">
      <v-form validate-on="submit lazy" v-model="form" @submit.prevent="submitNota">
        <p class="question">Escolha, 1 para muito descontente e 10 para muito satisfeito:</p>
        <v-text-field :rules="[required, range]" max="10" type="number" v-model="nota" variant="outlined" density="compact"
          label="Dê uma nota de 0 a 10"></v-text-field>

        <p class="question">Selecione os critérios que tiveram mais relevância para sua avaliação:</p>

        <v-row style="width: 100%; margin-left: 0%;">
          <div style="width: 48%; margin-top: 5%;" v-for="(criterio, index) in criterios" :key="index">
            <input type="checkbox" :name="criterio" :value="criterio" v-model="criteriosSelecionados" :id="criterio" />
            <label :for="criterio" class="label">{{ criterio }}</label>
          </div>
        </v-row>

        <v-btn style="margin-top: 15%;" @click="submitNota" type="submit" color="#660099" width="100%">Continuar</v-btn>
      </v-form>
    </div>

    <div v-else>
      <v-form validate-on="submit lazy" v-model="form" @submit.prevent="submitNota">
        <p class="question">Gostaria de deixar algum comentário?</p>
        <v-textarea :rules="[required]" v-model="comentario" variant="outlined" rows="7" density="compact" no-resize
          label="Escreva seu comentário..."></v-textarea>

        <v-btn style="margin-top: 15%;" @click="submitNota" type="submit" color="#660099" width="100%">Enviar</v-btn>
      </v-form>
    </div>

  </div>
</template>

<style scoped>
#avaliacao-final {
  padding: 5%;
  text-align: start;
}

.question {
  margin: 10px 0;
  font-size: 13px;
  color: #464646;
}

.label {
  color: #464646;
  margin-left: 10px;
}
</style>